// YouTube APIの読み込み
var tag = document.createElement('script');
tag.src = "https://www.youtube.com/iframe_api";
var firstScriptTag = document.getElementsByTagName('script')[0];
firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

//iframe player APIコードを非同期で読み込みます。
var player;

function onYouTubeIframeAPIReady() {
  //動画を埋め込む場所を指定(1.のidを入れる)
  player = new YT.Player('yt_player', {
    //YouTUbeの動画IDを入れる
    videoId: '-DXg0ro4RkM',
    //オプションを設定する場所
    playerVars: {
      'modestbranding': 1,
      'autohide': 1,
      'showinfo': 0,
      'playsinline': 1,
      'loop': 1,
      'listType': 'playlist',
      'playlist': '-DXg0ro4RkM', //上と同じ動画ID_リピートするには入力必須
      'rel': 0, // 関連動画の非表示
      'controls': 0, // 動画プレーヤーのコントロール非表示
    },

    events: {
      'onReady': onPlayerReady,
      'onStateChange': onPlayerStateChange,
    },
  });
}

//プレーヤの準備完了後に呼び出す関数
function onPlayerReady(event) {
  event.target.mute(); //ミュートにしないとスマホで再生されない
  event.target.playVideo(); //ビデオを再生
}

var done = false;

function onPlayerStateChange(event) {
  var ytStatus = event.target.getPlayerState();
  if (ytStatus == YT.PlayerState.ENDED) {
    event.target.mute(); //ミュートにしないとスマホで再生されない
    event.target.playVideo(); //ビデオを再生
  }
}


window.addEventListener('DOMContentLoaded', function() {
  // 上下左右に出てくる黒帯を非表示
  var $WIN = $(window); // ブラウザのウインドウを取得する
  var $HEADER = $(".header"); // 縦位置調整用のヘッダー要素を取得
  var $nav = $("#main-nav"); // 縦位置調整用のヘッダー要素を取得

  function screen_fit() {
    // 上下左右の縦横比を調節する関数
    const WIN_H = $WIN.height(); // windowの高さを取得
    const WIN_W = $WIN.width(); // windowの幅を取得
    const screen_switch = 0.5625; // youtubeの縦横比16:9=>9/16した値
    const screen_ratio = WIN_H / WIN_W; // windowの高さの値/windowの幅の値
    const ratio_H = WIN_H / screen_switch; // windowの高さ/縦横比の値
    const ratio_W = WIN_W * screen_switch; // windowの幅*縦横比の値
    const header_H = $HEADER.height(); //.headerの高さを取得

    if (screen_ratio > screen_switch) {
      // windowの高さの値/windowの幅の値>youtubeの縦横比16:9=>9/16した値
      $("#yt_player").css({ //動画を入れる場所のid名入れる
        width: ratio_H,
        height: "100%",
        "margin-top": "0",
        "margin-left": -ratio_H / 2,
        left: "50%",
        top: 0,
        "transition": "transform 450ms ",
      });
    } else {
      $("#yt_player").css({ //APIの場所のid名入れる
        width: "100%",
        height: ratio_W,
        "margin-top": -ratio_W / 2,
        "margin-left": 0,
        top: "50%",
        left: 0,
        "transition": "transform 450ms ",
      });
    }

    //$('.main-content').css('margin-top', '100vh');
  }

  if (!navigator.userAgent.match(/(iPhone|iPad|iPod|Android)/)) {
    function screen_position() {
      var nav_height = $nav.height();
      var yt_position = 223;
      var y;
      y = window.scrollY;

      if (y > 0 && $('.header').hasClass('fixed')) {
        $("#yt_player").css('transform', 'translateY(' + nav_height + 'px)');
      } else {
        $("#yt_player").css('transform', 'translateY(' + yt_position + 'px)');
      }
    }
  }


  $WIN.on("resize", function() {
    screen_fit();
  });

  $WIN.on("scroll", function() {
    screen_position();
  });

  $(function() {
    screen_fit();
  });

});


//console.log('mesa');